import { Link } from 'react-router-dom'

// ============================================================
// AccessDenied — the branded empty state for a route the member can't reach
// ============================================================
// Shown when a protected page determines (via useAccess) that the member lacks
// the capability. This is a UX courtesy so the page doesn't render broken/empty
// data pulls; the API is the real boundary and returns 403/404 regardless.

export function AccessDenied({
  title = 'You don’t have access to this area',
  detail = 'Your role doesn’t include this capability. Ask an account owner or admin if you need it.',
}: {
  title?: string
  detail?: string
}) {
  return (
    <div
      role="alert"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        minHeight: '60vh',
        padding: '2rem',
        gap: '0.75rem',
      }}
    >
      <div
        aria-hidden
        style={{
          width: 48,
          height: 48,
          borderRadius: 12,
          display: 'grid',
          placeItems: 'center',
          background: 'color-mix(in srgb, var(--accent-block) 16%, transparent)',
          color: 'var(--accent-block)',
          fontSize: 24,
        }}
      >
        {/* lock glyph, not a leaf/marketing icon */}
        ⚿
      </div>
      <h1 style={{ font: '600 1.35rem/1.2 var(--display, serif)', margin: 0 }}>{title}</h1>
      <p style={{ maxWidth: 440, color: 'var(--text-muted, #9aa)', margin: 0 }}>{detail}</p>
      <Link
        to="/today"
        style={{
          marginTop: '0.5rem',
          color: 'var(--accent-intel)',
          textDecoration: 'none',
          fontWeight: 600,
        }}
      >
        Back to Today
      </Link>
    </div>
  )
}

export default AccessDenied
